// extracted by mini-css-extract-plugin
export default {"vehiclesListFiltersWrapper":"vehicles-list-filters_vehiclesListFiltersWrapper__57g--"};